<cigna-omni-chat-bubble-container
  (events)="handleEvent($event)"
  [chatBubbleData]="chatBubbleData$ | async"
  [iconColors]="iconColors$ | async"
  [showButton]="showChatBubble$ | async"
  [icon]="icon"
  [shouldShowNewBubble]="shouldShowNewChatIcon$ | async"
  [isShellOpenOrMinimized]="isShellOpenOrMinimized$ | async"
  [isBubbleExpand]="expanderBubble$ | async"
  [isShellMinimized]="isShellMinimized$ | async"
  [isLiveChatAvailable]="isLiveChatAvailable"
></cigna-omni-chat-bubble-container>
